import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../firebase/config";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { collection, query, where, getDocs } from "firebase/firestore";

function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user] = useAuthState(auth);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", user.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setUserData(querySnapshot.docs[0].data());
        }
      }
    };

    fetchUserData();
  }, [user]);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsMenuOpen(false);
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // Kullanıcı giriş yapmamışsa public navbar'ı göster
  if (!user) {
    return (
      <nav className='bg-white shadow-md'>
        <div className='max-w-7xl mx-auto px-4'>
          <div className='flex justify-between h-16 items-center'>
            {/* Sol taraf - Logo ve FAQ */}
            <div className='flex items-center'>
              <Link to='/' className='flex items-center'>
                <span className='text-2xl font-architects-daughter text-blue-600'>
                  J1 Lists
                </span>
              </Link>
              <div className='hidden md:flex md:ml-6 space-x-4 items-center'>
                <Link
                  to='/faq'
                  className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                  FAQ
                </Link>
                <Link
                  to='/advice'
                  className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                  Advices
                </Link>
                <Link
                  to='/housing'
                  className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                  Housing List
                </Link>
                <Link
                  to='/jobs'
                  className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                  Job List
                </Link>
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className='hidden md:flex items-center space-x-4'>
              <Link
                to='/login'
                className='font-medium text-gray-700 hover:text-blue-600 px-4 py-2'>
                Login
              </Link>
              <Link
                to='/register'
                className='font-medium bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors'>
                Join the Community
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className='md:hidden'>
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className='inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 focus:outline-none'>
                <svg
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'>
                  {isMenuOpen ? (
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M6 18L18 6M6 6l12 12'
                    />
                  ) : (
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile menu */}
          {isMenuOpen && (
            <div className='md:hidden'>
              <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
                <Link
                  to='/housing'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                  Housing List
                </Link>
                <Link
                  to='/jobs'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                  Job List
                </Link>
                <Link
                  to='/faq'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                  FAQ
                </Link>
                 <Link
                  to='/advice'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                  Advices
                </Link>
                <Link
                  to='/login'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                  Login
                </Link>
                <Link
                  to='/register'
                  className='block px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50'>
                  Join the Community
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    );
  }

  // Giriş yapmış kullanıcı için navbar
  return (
    <nav className='bg-white shadow-md'>
      <div className='max-w-7xl mx-auto px-4'>
        <div className='flex justify-between h-16 items-center'>
          {/* Sol taraf - Logo ve FAQ */}
          <div className='flex items-center'>
            <Link to='/' className='flex items-center'>
              <span className='text-2xl font-architects-daughter text-blue-600'>
                J1 Lists
              </span>
            </Link>
            <div className='hidden md:flex md:ml-6 space-x-4 items-center'>
              <Link
                to='/faq'
                className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                FAQ
              </Link>
              <Link
                to='/advice'
                className='font-medium text-gray-700 hover:text-blue-600 px-3 py-2'>
                Advices
              </Link>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className='hidden md:flex items-center space-x-6'>
            {/* Username with Verified Badge */}
            <div className='flex items-center mr-4'>
              <span className='text-lg font-medium text-gray-700'>
                {userData?.username || user?.email}
              </span>
              <svg
                className='w-5 h-5 ml-1 text-blue-500'
                fill='currentColor'
                viewBox='0 0 20 20'>
                <path
                  fillRule='evenodd'
                  d='M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                  clipRule='evenodd'
                />
              </svg>
            </div>

            {/* Create Listing Button */}
            <button
              onClick={() => navigate("/create-listing")}
              className='bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors'>
              Create Listing
            </button>

            {/* My Listings */}
            <button
              onClick={() => navigate("/my-listings")}
              className='text-gray-700 font-medium hover:text-blue-600 transition-colors'>
              My Listings
            </button>

            {/* Settings */}
            <Link
              to='/settings'
              onClick={() => setIsMenuOpen(false)}
              className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
              Settings
            </Link>

            {/* Admin Panel - Only show for admin */}
            {user?.email === "j1listsinfo@gmail.com" && (
              <Link
                to='/admin'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-purple-600 hover:text-purple-700 hover:bg-purple-50'>
                Admin Panel
              </Link>
            )}

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className='bg-red-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-red-600 transition-colors'>
              Logout
            </button>
          </div>

          {/* Mobile menu button */}
          <div className='md:hidden'>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className='inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 focus:outline-none'>
              <svg
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'>
                {isMenuOpen ? (
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                ) : (
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M4 6h16M4 12h16M4 18h16'
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className='md:hidden'>
            <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
              {/* Username with Verified Badge */}
              <div className='flex items-center px-3 py-2'>
                <span className='text-lg font-medium text-gray-700'>
                  {userData?.username || user?.email}
                </span>
                <svg
                  className='w-5 h-5 ml-1 text-blue-500'
                  fill='currentColor'
                  viewBox='0 0 20 20'>
                  <path
                    fillRule='evenodd'
                    d='M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                    clipRule='evenodd'
                  />
                </svg>
              </div>

              {/* FAQ and Advices Links */}
              <Link
                to='/faq'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                FAQ
              </Link>
              <Link
                to='/advice'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                Advices
              </Link>

              {/* Create Listing */}
              <Link
                to='/create-listing'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50'>
                Create Listing
              </Link>

              {/* My Listings */}
              <Link
                to='/my-listings'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                My Listings
              </Link>

              {/* Settings */}
              <Link
                to='/settings'
                onClick={() => setIsMenuOpen(false)}
                className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50'>
                Settings
              </Link>

              {/* Admin Panel - Only show for admin */}
              {user?.email === "j1listsinfo@gmail.com" && (
                <Link
                  to='/admin'
                  onClick={() => setIsMenuOpen(false)}
                  className='block px-3 py-2 rounded-md text-base font-medium text-purple-600 hover:text-purple-700 hover:bg-purple-50'>
                  Admin Panel
                </Link>
              )}

              {/* Logout */}
              <button
                onClick={() => {
                  handleLogout();
                  setIsMenuOpen(false);
                }}
                className='w-full text-left px-3 py-2 rounded-md text-base font-medium text-red-600 hover:text-red-700 hover:bg-red-50'>
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
